import React from 'react';
import Chart from 'components/pure/charts/custom/Chart';
import AreaSeries from 'components/pure/charts/custom/AreaSeries';
import Guideline from 'components/pure/charts/custom/Guideline';
import Axis from 'components/pure/charts/custom/Axis';
import moment from 'moment';
import range from 'lodash/range';
import {scaleLinear, scaleTime} from 'd3-scale';
import './PercentageChart.styl';
import {CalloutArrow} from 'charts';

export default ({percentage: percentageVal, comparator, period, baseLabel, goalLabel}) => {
  const percentage = parseInt(percentageVal);
  const yValue = Math.max(140, percentage + 30);
  const comparisonYValue = Math.round(yValue - percentage) + 1;
  const ymax = Math.ceil(Math.max(yValue, comparisonYValue) * 1.35);
  const chartData = range(0, yValue + 1, yValue / 20).map((value, i) => {
    return {date: moment().add(i, 'day'), value};
  });
  const labels = [goalLabel, baseLabel];

  const compareChartData = range(0, comparisonYValue + 1, comparisonYValue / 20).map((value, i) => {
    return {date: moment().add(i, 'day'), value};
  });

  const margins = {left: 40, right: 0, top: 40, bottom: 5};
  const svgDimensions = {width: 275, height: 220};
  const xScale = scaleTime()
    .domain([chartData[0].date.toDate(), chartData[chartData.length - 1].date.toDate()])
    .range([margins.left, svgDimensions.width - margins.right]);

  const yScale = scaleLinear()
    .domain([0, ymax])
    .range([svgDimensions.height - margins.bottom, margins.top]);

  const scales = {xScale, yScale};
  // attempt to adjust the callout arrow offset based on the number of
  // characters in the label (not a perfect solution since characters
  // are not monospaced)
  const calloutOffset = comparator.length * 6;
  return (
    <div className="chart-container percentage-chart">
      <Chart
        placeholder={
          <div className="chart-title">
            {comparator} {percentage}%
          </div>
        }
        defs={CalloutArrow.getDefinitions()}
        svgDimensions={svgDimensions}
        margins={margins}
        bordered={true}>
        {[chartData, compareChartData].map((chartData, i) => (
          <g key={i}>
            <AreaSeries className="area" data={chartData} scales={scales} fill={'#FFFFFF'} />
            <Guideline
              scales={scales}
              goal={chartData[chartData.length - 1].value}
              baseline={chartData[chartData.length - 1].value}
              xMin={chartData[0].date}
              xMax={chartData[chartData.length - 1].date}>
              {/* TODO Need to perform text wrapping */}
              <text
                textAnchor="end"
                className={'goal-label'}
                x={scales.xScale.range()[1] - 5}
                y={scales.yScale(chartData[chartData.length - 1].value) + 10}>
                {labels[i]}
              </text>
            </Guideline>
          </g>
        ))}
        <CalloutArrow
          from={{
            x: svgDimensions.width - 10,
            /* arrow overextends so just manually shorten it */
            y: yScale(yValue) - 7,
          }}
          to={{x: margins.left + calloutOffset, y: 8}}
          delta={{x: 70, y: -30}}
        />
        <Axis
          orient="Bottom"
          scale={scales.xScale}
          translate={`translate(0, ${scales.yScale.range()[0]})`}
          tickSize={-5}
          ticks={9}
        />
        <Axis
          orient="Left"
          scale={scales.yScale}
          translate={`translate(${margins.left}, 0)`}
          tickSizeOuter={0}
          tickSizeInner={0}
          tickFormat={s => (s > 0 ? s + '%' : s)}
          tickValues={[0, comparisonYValue, yValue]}
        />
      </Chart>
      <div className="chart-period">
        {period || '3 Months'}
        <div className="period-arrow-container">
          <div className="arrow-shaft" />
          <div className="arrow-head" />
        </div>
      </div>
    </div>
  );
};
